import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2,      // data fresh for 2 minutes
      gcTime:    1000 * 60 * 10,     // cache kept for 10 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})
